import * as React from "react";
//import { StaticImage } from "gatsby-plugin-image";
import { StaticQuery, graphql } from "gatsby";
import ReactPlayer from "react-player";
import Uploader from "../components/uploader.js";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  FormText,
  FormFeedback,
  Label,
  Button,
  Input,
  InputGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as Styles from "./mainlayout.module.scss";

import logo from "../images/unitedlogo.png";
import rightimg from "../images/rightimg.png";

import unlockimg from "../images/unlock.png";
import pdficon from "../images/pdficon.png";
import emailicon from "../images/emailicon.png";
import applyicon from "../images/applyicon.png";
import pencilicon from "../images/pencilicon.png";
import cultureimg from "../images/culture.png";
import historyimg from "../images/history.png";
import testimonialsimg from "../images/testimonials.png";
import esopimg from "../images/esop.png";
import bonusimg from "../images/travel.png";
import fivestepimg from "../images/5step.png";
import benefitsimg from "../images/benefits.png";
import compimg from "../images/compensation.png";
import earthsmartimg from "../images/earthsmart.png";
import aathumb from "../images/thumbnail-Affirmative_Action.png";
import everifythumb from "../images/thumbnail-E-Verify.png";
import rtwthumb from "../images/thumbnail-OSC_Right_to_Work_poster.png";
// data

const cards = [
  {
    id: "culture",
    title: "Our Culture",
    img: cultureimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/vision-720p.mp4",
    duration: "1 min 58 sec",
    color: "#BC027F",
    colspan: "1",
    rowspan: "1",
  },
  {
    id: "testimonials",
    title: "Testimonials",
    img: testimonialsimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/testimonials21-720p.mp4",
    duration: "7 min 12 sec",
  },
  {
    id: "history",
    title: "Our History",
    img: historyimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/history21-720p.mp4",
    duration: "1 min 40 sec",
  },
  {
    id: "esop",
    title: "We Are Employee Owned",
    img: esopimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/esop-720p.mp4",
    duration: "1 min 27 sec",
  },
  {
    id: "travel",
    title: "Incentive Opportunities",
    img: bonusimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/travel21-web.mp4",
    duration: "2 min 2 sec",
  },
  {
    id: "benefits",
    title: "Benefits",
    img: benefitsimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/benefits21-web.mp4",
    duration: "1 min 26 sec",
    protected: true,
  },
  {
    id: "earthsmart",
    title: "Green and Earth Smart",
    img: earthsmartimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/earth-smart-720p.mp4",
    duration: "1 min 38 sec",
  },
  {
    id: "fivestep",
    title: "United's Selling Process",
    img: fivestepimg,
    hassrc: true,
    vidsrc:
      "https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/5step21-720p.mp4",
    duration: "12 min 31 sec",
    protected: true,
  },
  {
    id: "compensation",
    title: "New Rep Compensation Plan",
    img: compimg,
    hassrc: true,
    vidsrc: false,
    pdfsrc:
      "https://assets.unitedlabsinc.com/web/careers/NewRepCompPlan.pdf",
    protected: true,
  },
];

const ModalCardComponent = (props) => {
  const card = cards.find((card) => card.id === props.card);
  const locked = props.locked;
  const [modal, setModal] = React.useState(false);
  const [playing, setPlaying] = React.useState(false);
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false);
  const toggle = () => {
    if (card.pdfsrc) {
      window.open(
        "https://assets.unitedlabsinc.com/web/careers/NewRepCompPlan.pdf"
      );
    } else {
      setModal(!modal);
    }
  };
  const blocktoggle = () => setModal(modal);

  return (
    <div className={Styles.card}>
      <div onClick={locked ? blocktoggle : toggle} className={Styles.index}>
        <img src={card.img} alt={card.title} className={Styles.cardImg} />
      </div>

      <div
        className={Styles.cardTitle}
        onClick={locked ? blocktoggle : toggle}
        role="link"
        tabIndex={card.index}
      >
        {card.title}
        <br />
        <span style={{ fontSize: "12px" }}>{card.duration}</span>
        {card.pdfsrc && (
          <span>
            <img src={pdficon} alt="pdficon" style={{ height: "32px" }} />{" "}
            Download the PDF
          </span>
        )}
      </div>
      {(() => {
        if (locked) {
          return (
            <div className={Styles.comingSoon}>
              <img src={unlockimg} alt="unlock" />
            </div>
          );
        }
      })()}
      {card.vidsrc && (
        <Modal
          isOpen={modal}
          toggle={toggle}
          unmountOnClose={false}
          onOpened={play}
          onClosed={pause}
          size="lg"
          key={card.id}
        >
          <ModalHeader toggle={toggle}>{card.title}</ModalHeader>
          <ModalBody>
            <ReactPlayer
              url={card.vidsrc}
              controls
              playing={playing}
              width="100%"
            />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {card.pdfsrc && (
        <Modal
          isOpen={modal}
          toggle={toggle}
          unmountOnClose={false}
          size="lg"
          key={card.id}
        >
          <ModalHeader toggle={toggle}>{card.title}</ModalHeader>
          <ModalBody>
            <div></div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
};
const AppModalComponent = (props) => {
  const [modal, setModal] = React.useState(false);
  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button
        color="success"
        style={{
          textTransform: "uppercase",
          fontWeight: "bold",
          fontSize: "1.1em",
          margin: "15px",
        }}
        onClick={toggle}
      >
        Upload My
        <br />
        Resume Today
      </Button>

      <Modal toggle={toggle} isOpen={modal} unmountOnClose={false} size="lg">
        <ModalHeader toggle={toggle}>Select Resume to Upload</ModalHeader>
        <ModalBody>
          <Uploader recemail={props.recemail} />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </div>
  );
};

class MainLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code1InputValue: "",
      code2InputValue: "",
      code1Validated: false,
      code2Validated: false,
      code1AttemptCount: 0,
      code2AttemptCount: 0,
      recemail: "recruiter@unitedlabsinc.com",
    };
    this.handleCode1InputChange = this.handleCode1InputChange.bind(this);
    this.handleCode1Submit = this.handleCode1Submit.bind(this);
    this.handleCode2InputChange = this.handleCode2InputChange.bind(this);
    this.handleCode2Submit = this.handleCode2Submit.bind(this);
    this.handleRecSelectChange = this.handleRecSelectChange.bind(this);
  }

  handleRecSelectChange(event) {
    this.setState({ recemail: event.target.value });
  }
  handleCode1Submit(event) {
    event.preventDefault();
    if (this.state.code1InputValue.toLowerCase() === "upward2025") {
      this.setState({ code1Validated: true });
    } else {
      this.setState({ code1AttemptCount: this.state.code1AttemptCount + 1 });
    }
  }
  handleCode2Submit(event) {
    event.preventDefault();
    if (this.state.code2InputValue.toLowerCase() === "success2025") {
      this.setState({ code2Validated: true });
    } else {
      this.setState({ code2AttemptCount: this.state.code2AttemptCount + 1 });
    }
  }
  async handleCode1InputChange(event) {
    await this.setState({ code1InputValue: event.target.value });
    if (this.state.code1InputValue.toLowerCase() === "upward2025") {
      this.setState({ codeValidated: true });
    }
  }
  async handleCode2InputChange(event) {
    await this.setState({ code2InputValue: event.target.value });
    if (this.state.code2InputValue.toLowerCase() === "success2025") {
      this.setState({ code2Validated: true });
    }
  }
  render() {
    let go1ButtonText = this.state.code1Validated ? "Code Valid" : "Go";

    let go1ButtonColor = this.state.code1Validated ? "success" : "primary";
    let go2ButtonText = this.state.code2Validated ? "Code Valid" : "Go";

    let go2ButtonColor = this.state.code2Validated ? "success" : "primary";
    let invalidCode1Feedback =
      this.state.code1AttemptCount < 2
        ? "That code word is not valid."
        : "Need Help? Contact your recruiter for a code word to view this content.";
    let invalidCode2Feedback =
      this.state.code2AttemptCount < 2
        ? "That code word is not valid."
        : "Need Help? Contact your recruiter for a code word to view this content.";
    return (
      <div className={Styles.page}>
        <Container className={Styles.mainContainerDiv} fluid="sm">
          <Row className={Styles.headerRow}>
            <Col className={Styles.headerLeftCol} md="4">
              <a href="https://internal.unitedlabsinc.com">
                <img src={logo} alt="logo" className={Styles.logoImg} />
              </a>
            </Col>
            <Col className={Styles.headerRightCol} md="8">
              <img src={rightimg} alt="app preview screens" />
            </Col>
          </Row>
          <Row>
            <Col md="12" className={Styles.welcomeCol}>
              <h1>Welcome to United Laboratories</h1>
              <p>
                At United, not only do we focus on manufacturing quality
                products, we focus on people, and creating a family atmosphere.
                From our passion to continue to grow through our customers{"' "}
                success, to our drive to create a workplace where every person
                can reach his or her full potential; we are committed to
                offering stability, while setting industry standards for
                environmentally preferred specialty products.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md="6" className={Styles.welcomeVidCol}>
              <ReactPlayer
                url="https://s3.amazonaws.com/ulabs.info/Transcoded+Media+Files/hr/recruiting/welcome/welcome-web.mp4"
                width="90%"
                height="90%"
                style={{
                  marginTop: "-10px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                controls
              />
            </Col>
            <Col md="6">
              <Row style={{ paddingTop: "15px" }}>
                <Col>
                  <ModalCardComponent card="culture" />
                </Col>
                <Col>
                  <ModalCardComponent card="testimonials" />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs="6" md="3">
              <ModalCardComponent card="history" />
            </Col>
            <Col xs="6" md="3">
              <ModalCardComponent card="esop" />
            </Col>
            <Col xs="6" md="3">
              <ModalCardComponent card="travel" />
            </Col>
            <Col xs="6" md="3">
              <ModalCardComponent card="earthsmart" />
            </Col>
          </Row>

          <Container>
            <Row className={Styles.protectedRow}>
              <Col md="8" className={Styles.protectedCol}>
                <div className={Styles.protectedColDiv}>
                  <h2>
                    Please use the CODE given to you by your recruiter to view
                    the following information:
                  </h2>

                  <Form
                    onSubmit={this.handleCode1Submit}
                    className={Styles.codeForm}
                  >
                    <StaticQuery
                      query={graphql`
                        {
                          allRecruiter {
                            nodes {
                              email
                              firstName
                              lastName
                            }
                          }
                        }
                      `}
                      render={(data) => (
                        <FormGroup row>
                          <Col md="4">
                            <Label for="exampleSelect">
                              Select Your Recruiter:
                            </Label>
                          </Col>

                          <Col md="6">
                            <Input
                              id="exampleSelect"
                              name="select"
                              type="select"
                              className={Styles.codeInput}
                              onChange={this.handleRecSelectChange}
                            >
                              <option value="recruiter@unitedlabsinc.com">
                                {" "}
                              </option>
                              {data.allRecruiter.nodes
                                .sort((a, b) =>
                                  a.lastName > b.lastName ? 1 : -1
                                )
                                .map((recruiter, index) => (
                                  <option
                                    value={recruiter.email}
                                    key={recruiter.email}
                                  >
                                    {recruiter.firstName} {recruiter.lastName}
                                  </option>
                                ))}
                            </Input>
                          </Col>
                        </FormGroup>
                      )}
                    ></StaticQuery>
                    <FormGroup row>
                      <Col md="4">
                        <Label for="codeInput">
                          Enter Code Here to Unlock:
                        </Label>
                      </Col>
                      <Col md="6">
                        <InputGroup>
                          <Input
                            id="codeInput"
                            name="codeInput"
                            className={Styles.codeInput}
                            value={this.state.code1Inputvalue}
                            onChange={this.handleCode1InputChange}
                            valid={this.state.code1Validated}
                            disabled={this.state.code1Validated}
                            invalid={
                              this.state.code1AttemptCount > 0 &&
                              !this.state.code1Validated
                            }
                          />

                          <Button
                            type="submit"
                            color={go1ButtonColor}
                            disabled={this.state.code1Validated}
                            style={{
                              textTransform: "uppercase",
                              fontWeight: "bold",
                              fontSize: ".9em",
                            }}
                          >
                            {go1ButtonText}
                          </Button>

                          <FormFeedback>{invalidCode1Feedback}</FormFeedback>
                        </InputGroup>
                      </Col>
                    </FormGroup>
                  </Form>
                  <Row
                    className={
                      !this.state.code1Validated ? Styles.lockedRow : " "
                    }
                  >
                    <Col sm="6" md="6">
                      <ModalCardComponent
                        card="benefits"
                        locked={!this.state.code1Validated}
                      />
                    </Col>
                    <Col sm="6" md="6">
                      <ModalCardComponent
                        card="fivestep"
                        locked={!this.state.code1Validated}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col className={Styles.protectedCol} sm="4" md="4">
                <div className={Styles.protectedColDiv}>
                  <h2>
                    Please use the Compensation Plan CODE given to you by your
                    recruiter to view the Compensation Plan:
                  </h2>

                  <Form
                    onSubmit={this.handleCode2Submit}
                    className={Styles.codeForm}
                  >
                    <FormGroup row>
                      <Col md="3">
                        <Label for="codeInput">Code:</Label>
                      </Col>
                      <Col md="8">
                        <InputGroup>
                          <Input
                            id="codeInput"
                            name="codeInput"
                            className={Styles.codeInput}
                            value={this.state.code2Inputvalue}
                            onChange={this.handleCode2InputChange}
                            valid={this.state.code2Validated}
                            disabled={this.state.code2Validated}
                            invalid={
                              this.state.code2AttemptCount > 0 &&
                              !this.state.code2Validated
                            }
                          />

                          <Button
                            type="submit"
                            color={go2ButtonColor}
                            disabled={this.state.code2Validated}
                            style={{
                              textTransform: "uppercase",
                              fontWeight: "bold",
                              fontSize: ".9em",
                            }}
                          >
                            {go2ButtonText}
                          </Button>

                          <FormFeedback>{invalidCode2Feedback}</FormFeedback>
                        </InputGroup>
                      </Col>
                    </FormGroup>
                  </Form>
                  <Row
                    className={
                      !this.state.code2Validated ? Styles.lockedRow : " "
                    }
                  >
                    <Col md="12">
                      <ModalCardComponent
                        card="compensation"
                        locked={!this.state.code2Validated}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>

          <Container className={Styles.applyContainer}>
            <h2>How Do I Apply?</h2>
            <Row>
              <Col className={Styles.applyCol}>
                <div
                  className={Styles.applyColDiv}
                  style={{
                    backgroundColor: "#9dda5b",
                  }}
                >
                  <a
                    href="mailto:recruiter@unitedlabsinc.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={emailicon}
                      alt="email icon"
                      style={{
                        height: "42px",
                        margin: "15px",
                      }}
                    />
                    <br />
                    <span
                      style={{
                        textTransform: "uppercase",
                        fontWeight: "bold",
                      }}
                    >
                      eMail Our Recruiter
                      <br />
                    </span>
                    <span
                      style={{
                        color: "#7f0aca",
                        textDecoration: "underline",
                        fontWeight: "bold",
                        fontSize: ".8rem",
                      }}
                    >
                      recruiter@unitedlabsinc.com
                      <br />
                      <br />
                    </span>
                  </a>
                </div>
              </Col>
              <Col className={Styles.applyCol} sm="6" md="4">
                <div
                  className={Styles.applyColDiv}
                  style={{
                    backgroundColor: "#004ba0",
                  }}
                >
                  <img
                    src={applyicon}
                    alt="apply icon"
                    style={{
                      height: "32px",
                      margin: "15px",
                    }}
                  />
                  <span
                    style={{
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      fontSize: "1.1em",
                      margin: "15px",
                      color: "#FFF",
                    }}
                  >
                    Apply Now
                  </span>
                  <AppModalComponent recemail={this.state.recemail} />
                </div>
              </Col>
              <Col className={Styles.applyCol}>
                <div
                  className={Styles.applyColDiv}
                  style={{
                    backgroundColor: "#9dda5b",
                  }}
                >
                  <a
                    href={
                      "https://internal.unitedlabsinc.com/recruiting/app/?recemail=" +
                      this.state.recemail
                    }
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <img
                      src={pencilicon}
                      alt="pencil icon"
                      style={{
                        height: "32px",
                        margin: "15px",
                      }}
                    />
                    <br />
                    <Button
                      color="primary"
                      style={{
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        fontSize: "1.1em",
                        margin: "15px",
                        backgroundColor: "#004b9f",
                      }}
                    >
                      Fill Out
                      <br />
                      Sales Application
                    </Button>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>

          <Container className={Styles.infoContainer}>
            <h2>Important information for your review</h2>
            <Row>
              <Col className={Styles.infoCol}>
                <div className={Styles.infoColDiv}>
                  <a
                    href="https://internal.unitedlabsinc.com/recruiting/pdf/EEO_AAP_Policy.pdf"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <span>
                      Equal Opportunity Affirmative Action Policy
                      <br />
                      <img src={aathumb} />
                    </span>
                  </a>
                </div>
              </Col>
              <Col className={Styles.infoCol} sm="6" md="4">
                <div className={Styles.infoColDiv}>
                  <a
                    href="https://internal.unitedlabsinc.com/recruiting/pdf/E-Verify_Participation_Poster_ES-092017.pdf"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <span>
                      E-Verify Participation
                      <br />
                      <img src={everifythumb} />
                    </span>
                  </a>
                </div>
              </Col>
              <Col className={Styles.infoCol}>
                <div className={Styles.infoColDiv}>
                  <a
                    href="https://s3.amazonaws.com/ulabs.info-assets/assets/pdf/hr/Right+to+Work+Poster.pdf"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Right to Work
                    <br />
                    <img src={rtwthumb} />
                    <br />
                  </a>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                Also feel free to submit the following optional forms:
                <ul>
                  <li>
                    <a
                      href="https://internal.unitedlabsinc.com/recruiting/application/Invitation_Self_Identify_Disability.asp?recemail=recruiter@unitedlabsinc.com"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Invitation Self Identify Form - Disability
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://internal.unitedlabsinc.com/recruiting/application/Invitation_Self_Identify_Race_Gender.asp?recemail=recruiter@unitedlabsinc.com"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Invitation Self Identify Form - Race and Gender
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        "https://internal.unitedlabsinc.com/recruiting/application/Invitation_Self_Identify_Veterans_Pre-Offer.asp?recemail=" +
                        this.state.recemail
                      }
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Invitation Self Identify Form - Veterans (Pre-Offer)
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
    );
  }
}

export default MainLayout;
